module.exports = "<div>\n\t<ul>\n\t\t<li>1.在2016年12月16日前开通的金钻用户，可不选择金钻新路线，老路线保持至12月16日前开通的金钻时长到期。</li>\n\t\t<li>2.老路线用户开通金钻时长或者在活动中领取金钻时长奖品（即有新的金钻时长增加）后，必须选择新金钻路线，否则所有金钻外显特权将置灰，无法正常显示。选择新路线后将按路线正常显示</li>\n\t</ul>\n\t<p style=\"text-align:right;\"><label><input type=\"checkbox\"  ms-duplex-checked=\"@hasRead\"/>已经阅读</label></p>\n</div>";


//////////////////
// WEBPACK FOOTER
// /usr/local/src/vipp-cli/web_modules/component/hdplatform/drawgift/donateB/svipWay.html
// module id = 49
// module chunks = 0